import { Box, Drawer } from '@mui/material'
import { MediaDetailsContent } from '@/features/media-details/Content'
import {
  getMediaDetailsState,
  setMediaDetailsState,
} from '@/features/media-details/slice'
import { useAppDispatch, useAppSelector } from '@/redux/hooks'
import { MediaSizes } from '../media/types'
import { useMediaImage } from '../media/useMediaImage'
import type { SearchResultItem } from '../search/types'

const EMPTY_ITEM = {} as SearchResultItem

export const MediaDetailsDrawer = () => {
  const dispatch = useAppDispatch()
  const { openDrawer, searchResultItem } =
    useAppSelector(getMediaDetailsState).mediaDetailsState

  const shouldFetch = openDrawer && !!searchResultItem

  const { url, request } = useMediaImage(
    searchResultItem ?? EMPTY_ITEM,
    MediaSizes.Medium,
    shouldFetch,
  )

  const isReady =
    openDrawer && !!searchResultItem && !!url && !request.isFetching

  return (
    <Drawer
      open={isReady}
      anchor="right"
      onClose={() =>
        dispatch(
          setMediaDetailsState({
            openDrawer: false,
            searchResultItem: null,
          }),
        )
      }
    >
      <Box sx={{ width: 704, p: '16px' }}>
        {isReady && (
          <MediaDetailsContent
            openDrawer={openDrawer}
            searchResultItem={searchResultItem}
            url={url}
          />
        )}
      </Box>
    </Drawer>
  )
}
